export class InternalConfiguration {
  machineSaleCashlessServiceDisableNavigation = false;
}
